import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/tenant-profile/')({
  beforeLoad: (): void => {
    throw redirect({ to: '/settings/tenant-profile/general' });
  },
});
